package org.hs_soft.runmynesto.domain.util.helper

import org.hs_soft.runmynesto.domain.config.language.GermanStrings
import kotlinx.browser.window
import org.hs_soft.runmynesto.domain.config.language.EnglishStrings
import org.hs_soft.runmynesto.domain.config.language.FrenchStrings
import org.hs_soft.runmynesto.domain.config.language.ItalianoStrings
import org.hs_soft.runmynesto.domain.config.language.StringResources
import org.hs_soft.runmynesto.domain.model.home.options.LanguageEnum
import org.hs_soft.runmynesto.domain.util.IdUtils


object LanguageManager {
    private var currentStrings: StringResources = EnglishStrings

    fun initialize() {
        val savedLanguage = window.localStorage.getItem(IdUtils.language)
        setLanguage(savedLanguage)
    }

    fun setLanguage(language: String?) {
        currentStrings = when (language) {
            LanguageEnum.German.value -> GermanStrings
            LanguageEnum.French.value ->FrenchStrings
            LanguageEnum.Italian.value->ItalianoStrings
            LanguageEnum.English.value -> EnglishStrings
            else -> EnglishStrings
        }
    }

    fun getCurrentStrings(): StringResources = currentStrings
}